/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CarrierSelect/view.blocks to change it.
import Content from './Content/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CarrierSelect({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AddAction/Content/Content/Filter/CarrierSelect"
  
}) {
  return (<React.Fragment
>
<Content
  viewPath={`${viewPath}/Content`}
/>
{children}
</React.Fragment>)
}